import { useQuery } from '@tanstack/react-query';
import { ApiCompanyAndContactsRepository } from 'services/company-and-contacts/ApiCompanyAndContactsRepository';
import { QueryKeys } from 'utils/queryKeys';

import type { CompositeEntityId } from 'services/company-and-contacts/mappers';

export const useGetCrmCompanyByIdQuery = (companyId: CompositeEntityId | undefined | null, options: { enabled?: boolean } = {}) => {
  const { enabled = true } = options;
  return useQuery({
    queryKey: QueryKeys.getCrmCompanyById(companyId),
    queryFn: () => (companyId ? ApiCompanyAndContactsRepository.getCrmCompanyById(companyId) : Promise.reject(new Error('invalid id'))),
    enabled: enabled && !!companyId,
  });
};
